import React from "react";
import LegalPageShell from "../components/LegalPageShell";

/**
 * Privacy Policy hostata da Iubenda — embed via iframe.
 * Sempre aggiornata automaticamente, conforme GDPR.
 */
export default function PrivacyPolicy() {
  return (
    <LegalPageShell
      title="Privacy Policy"
      subtitle="Informativa sul trattamento dei dati personali ai sensi degli articoli 13 e 14 del Regolamento UE 2016/679 (GDPR). Aggiornata e generata tramite Iubenda."
      testid="page-privacy-policy"
    >
      <div className="rounded-3xl border border-[var(--mp-ink)] bg-white shadow-brutal-sm overflow-hidden">
        <iframe
          src="https://www.iubenda.com/privacy-policy/22650933"
          title="Privacy Policy"
          data-testid="iubenda-privacy-iframe"
          className="w-full"
          style={{ height: "1600px", border: "0" }}
        />
      </div>
      <div className="mt-6 text-sm text-[var(--mp-muted)]">
        Documento ospitato da Iubenda. Per problemi di visualizzazione,{" "}
        <a
          href="https://www.iubenda.com/privacy-policy/22650933"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-[var(--mp-ink)]"
          data-testid="privacy-policy-fallback-link"
        >
          apri la Privacy Policy in una nuova scheda
        </a>
        .
      </div>
    </LegalPageShell>
  );
}
